<template>
  <main v-if="view < 5" class="split">
    <div class="left">
      <img src="/img/signup-image.png" />
      <div class="text">
        <div class="marked">
          <h2>{{ $t('views.Signup.analysingPerformanceTitle') }}</h2>
        </div>
        <p>
          {{ $t('views.Signup.analysingPerformanceText1') }}
        </p>

        <p v-html="$t('views.Signup.analysingPerformanceText2')" />
      </div>
    </div>
    <div class="right">
      <div class="marked">
        <h1>{{ $t('views.Signup.title') }}</h1>
      </div>

      <p>
        {{ $t('views.Signup.alreadyHaveAccount') }}
        <a href="https://my.meqyas.sa/login" target="_blank">
          {{ $t('views.Signup.signIn') }}
        </a>
      </p>

      <form v-if="view === 1" @submit.prevent="formSubmit">
        <div class="marked">
          <h2>{{ $t('views.Signup.confirmation') }}</h2>
        </div>

        <ul class="project-requirements">
          <li>
            <label>
              <input
                v-model="requirementsForm.fixedConnection"
                type="checkbox"
              />
              {{ $t('views.Signup.fixedInternet') }}
            </label>
          </li>
          <li>
            <label>
              <input v-model="requirementsForm.someSpace" type="checkbox" />
              {{ $t('views.Signup.someSpace') }}
            </label>
          </li>
          <li>
            <label>
              <input v-model="requirementsForm.sparePower" type="checkbox" />
              {{ $t('views.Signup.sparePower') }}
            </label>
          </li>
        </ul>

        <Button
          :disabled="
            !requirementsForm.fixedConnection ||
              !requirementsForm.someSpace ||
              !requirementsForm.sparePower
          "
          type="submit"
          class="btn-primary"
        >
          {{ $t('common.btnNext') }}
        </Button>
      </form>

      <form v-else-if="view === 3" @submit.prevent="isCityValid">
        <h2>{{ $t('views.Signup.installationAddress') }}</h2>
        <div class="form-field">
          <label for="install_address_1">
            {{ $t('views.Signup.addressLine', { line: '$t(common.one)' }) }}
          </label>
          <input
            id="install_address_1"
            v-model="formData.installation_address_1"
            type="text"
            required
          />
        </div>
        <div class="form-field">
          <label for="install_address_2">
            {{ $t('views.Signup.addressLine', { line: '$t(common.two)' }) }}
          </label>
          <input
            id="install_address_2"
            v-model="formData.installation_address_2"
            type="text"
          />
        </div>
        <div class="form-field">
          <label for="install_address_3">
            {{ $t('views.Signup.addressLine', { line: '$t(common.three)' }) }}
          </label>
          <input
            id="install_address_3"
            v-model="formData.installation_address_3"
            type="text"
          />
        </div>
        <div :class="{ error: installCityError }" class="form-field">
          <label for="install_city">{{ $t('views.Signup.city') }}</label>
          <input
            id="install_city"
            v-model="formData.installation_city"
            type="text"
            list="install-cities"
            required
          />
          <datalist id="install-cities">
            <option
              v-for="(city, index) in citiesList"
              :key="`install-city-${index}`"
            >
              {{ city }}
            </option>
          </datalist>
          <p v-if="installCityError" class="margin-top-sm">
            {{ $t('views.Signup.cityError', { city: invalidInstallCity }) }}
          </p>
        </div>
        <div class="form-field">
          <label for="install_postcode">
            {{ $t('views.Signup.postcode') }}
          </label>
          <input
            id="install_postcode"
            v-model="formData.installation_postcode"
            type="text"
            required
          />
        </div>
        <div class="form-field">
          <label for="install_country">
            {{ $t('views.Signup.country') }}
          </label>
          <input
            id="install_country"
            v-model="formData.installation_country"
            type="text"
            disabled
          />
        </div>
        <div class="form-field">
          <label>
            <input v-model="deliveryAddressSame" type="checkbox" />
            {{ $t('views.Signup.sameAsInstallation') }}
          </label>
        </div>

        <div v-if="!deliveryAddressSame">
          <h2>{{ $t('views.Signup.deliveryAddress') }}</h2>
          <div class="form-field">
            <label for="delivery_address_1">
              {{ $t('views.Signup.addressLine', { line: '$t(common.one)' }) }}
            </label>
            <input
              id="delivery_address_1"
              v-model="formData.delivery_address_1"
              type="text"
              required
            />
          </div>
          <div class="form-field">
            <label for="delivery_address_2">
              {{ $t('views.Signup.addressLine', { line: '$t(common.two)' }) }}
            </label>
            <input
              id="delivery_address_2"
              v-model="formData.delivery_address_2"
              type="text"
            />
          </div>
          <div class="form-field">
            <label for="delivery_address_3">
              {{ $t('views.Signup.addressLine', { line: '$t(common.three)' }) }}
            </label>
            <input
              id="delivery_address_3"
              v-model="formData.delivery_address_3"
              type="text"
            />
          </div>
          <div :class="{ error: deliveryCityError }" class="form-field">
            <label for="delivery_city">{{ $t('views.Signup.city') }}</label>
            <input
              id="delivery_city"
              v-model="formData.delivery_city"
              type="text"
              list="delivery-cities"
              required
            />
            <datalist id="delivery-cities">
              <option
                v-for="(city, index) in citiesList"
                :key="`delivery-city-${index}`"
              >
                {{ city }}
              </option>
            </datalist>
            <p v-if="deliveryCityError" class="margin-top-sm">
              {{ $t('views.Signup.cityError', { city: invalidDeliveryCity }) }}
            </p>
          </div>
          <div class="form-field">
            <label for="postcode">{{ $t('views.Signup.postcode') }}</label>
            <input
              id="postcode"
              v-model="formData.delivery_postcode"
              type="text"
              required
            />
          </div>
          <div class="form-field">
            <label for="country">{{ $t('views.Signup.country') }}</label>
            <input
              id="country"
              v-model="formData.delivery_country"
              type="text"
              disabled
            />
          </div>
        </div>
        <div class="buttons">
          <Button
            type="button"
            class="btn-primary btn-revert"
            @click.native="view = view - 1"
          >
            {{ $t('common.btnBack') }}
          </Button>

          <Button
            :isSuccess="success"
            :isLoading="loading"
            type="submit"
            class="btn-primary"
          >
            {{ $t('common.btnNext') }}
          </Button>
        </div>
      </form>

      <form v-else @submit.prevent="formSubmit">
        <fieldset :disabled="loading">
          <div v-if="view === 2">
            <div class="form-field">
              <label for="name">{{ $t('views.Signup.firstName') }}</label>
              <input
                id="name"
                v-model="formData.first_name"
                type="text"
                required
              />
            </div>
            <div class="form-field">
              <label for="subject">{{ $t('views.Signup.lastName') }}</label>
              <input
                id="subject"
                v-model="formData.last_name"
                type="text"
                required
              />
            </div>
            <div class="form-field">
              <label for="email">{{ $t('views.Signup.email') }}</label>
              <input
                id="email"
                v-model="formData.email"
                type="email"
                required
              />
            </div>
            <div class="form-field">
              <label for="phone">{{ $t('views.Signup.phone') }}</label>
              <input id="phone" v-model="formData.mobile" type="tel" required />
            </div>
          </div>

          <div v-if="view === 4">
            <div class="form-field">
              <label for="isp">{{ $t('views.Signup.isp') }}</label>
              <select
                id="isp"
                v-model="formData.ispId"
                :disabled="ispInputDisabled"
                class="form-control"
                required
              >
                <option :value="undefined" disabled>
                  {{ $t('views.Signup.yourISP') }}
                </option>
                <option
                  v-for="isp in ispsForCountry"
                  :value="isp.id"
                  :key="isp.id"
                >
                  {{ isp.name }}
                </option>
                <option :value="0">{{ $t('views.Signup.other') }}</option>
                <option :value="-1">{{ $t('views.Signup.dunno') }}</option>
              </select>

              <input
                v-if="formData.ispId === 0"
                v-model="formData.ispOther"
                :placeholder="$t('views.Signup.enterISP')"
                type="text"
                class="form-control margin-top-1em"
              />
            </div>

            <div class="form-field">
              <label for="product">{{ $t('views.Signup.product') }}</label>
              <select
                id="product"
                v-model="formData.productId"
                class="form-control"
                required
              >
                <option :value="undefined" disabled>
                  {{ $t('views.Signup.yourProduct') }}
                </option>
                <option
                  v-for="product in productsForIsp"
                  :key="product.id"
                  :value="product.id"
                >
                  {{ product.name }}
                </option>
                <option :value="0">{{ $t('views.Signup.other') }}</option>
                <option :value="-1">{{ $t('views.Signup.dunno') }}</option>
              </select>

              <input
                v-if="formData.productId === 0"
                v-model="formData.productOther"
                :placeholder="$t('views.Signup.enterProduct')"
                type="text"
                class="form-control margin-top-1em"
              />
            </div>
            <div class="form-field other">
              <label for="other">Other</label>
              <input id="other" v-model="formData.other" type="text" />
            </div>
            <div class="form-field">
              <label>
                <input v-model="formData.tos" type="checkbox" required />
                <span v-html="$t('views.Signup.eula')" />
              </label>
            </div>
          </div>

          <p v-if="errorCode">
            {{ $t('views.Signup.error') }}
          </p>

          <div class="buttons">
            <Button
              type="button"
              class="btn-primary btn-revert"
              @click.native="view = view - 1"
            >
              {{ $t('common.btnBack') }}
            </Button>

            <Button
              :isSuccess="success"
              :isLoading="loading"
              type="submit"
              class="btn-primary"
            >
              {{ $t(`common.btn${view === 4 ? 'Submit' : 'Next'}`) }}
            </Button>
          </div>
        </fieldset>
      </form>
    </div>
  </main>
  <main v-else class="split split--thanks">
    <div class="left">
      <div class="text">
        <div class="marked">
          <h1>{{ $t('views.Signup.thanksTitle') }}</h1>
        </div>
        <p>{{ $t('views.Signup.thanksText') }}</p>
        <h2>{{ $t('views.Signup.inTheMeantimeTitle') }}</h2>
        <i18next path="views.Signup.inTheMeantimeText" tag="p">
          <router-link to="reports" place="reports">{{
            $t('common.here')
          }}</router-link>
        </i18next>
      </div>
    </div>
    <div class="right">
      <img src="/img/meqyas-whitebox.png" />
    </div>
  </main>
</template>
<script>
import Vue from 'vue';
import Button from '@/components/Button';
import * as signupsService from '@/services/signups';
import i18next from 'i18next';
import cities from '../helpers/cities';

export default {
  name: 'Signup',
  components: {
    Button
  },
  metaInfo() {
    return {
      title: 'Volunteer now'
    };
  },
  data() {
    return {
      view: 1,
      isps: undefined,
      loading: false,
      success: false,
      countries: [],
      enCities: cities.enCities,
      arCities: cities.arCities,
      requirementsForm: {
        fixedConnection: false,
        someSpace: false,
        sparePower: false
      },
      deliveryAddressSame: true,
      formData: {
        installation_address_1: '',
        installation_address_2: '',
        installation_address_3: '',
        installation_city: undefined,
        installation_postcode: '',
        installation_country: 'Saudi Arabia',
        installation_phone: '',

        delivery_address_1: '',
        delivery_address_2: '',
        delivery_address_3: '',
        delivery_city: undefined,
        delivery_postcode: '',
        delivery_country: 'Saudi Arabia',
        delivery_phone: '',

        first_name: undefined,
        last_name: undefined,
        email: undefined,
        mobile: undefined,
        language_preference: Vue.config.lang.replace('-', '_'),
        ispId: undefined,
        productId: undefined,
        productOther: undefined,
        ispOther: undefined,
        // honeypot
        other: null,
        tos: false
      },
      ispInputDisabled: false,
      errorCode: undefined,
      formFeedback: [],
      lang: Vue.config.lang,
      installCityError: false,
      invalidInstallCity: '',
      deliveryCityError: false,
      invalidDeliveryCity: ''
    };
  },
  computed: {
    ispsForCountry() {
      const countryId = 195;
      const country = this.countries.find(({ id }) => id === countryId);
      return (
        country &&
        country.isps.sort((a, b) =>
          a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1
        )
      );
    },
    productsForIsp() {
      if (!this.ispsForCountry) {
        return [];
      }
      const isp = this.ispsForCountry.find(
        ({ id }) => id === this.formData.ispId
      );
      return isp ? isp.packages : [];
    },
    citiesList() {
      if (this.lang === 'ar-SA') {
        return this.arCities;
      }
      const sortedEnCities = [...this.enCities].sort();
      return sortedEnCities;
    }
  },
  mounted() {
    i18next.on('languageChanged', () => {
      this.lang = Vue.config.lang;
    });

    signupsService.getMetaData().then(data => {
      this.countries = data.data.countryData;
      const query = this.$route.query;

      if (query.isp) {
        this.formData.ispId = Number(query.isp);
        this.ispInputDisabled = true;
      }

      if (query.product) {
        this.formData.productId = Number(query.product);
      }
    });
  },
  methods: {
    capitalise(string) {
      const lowerCase = string.toLowerCase();
      const words = lowerCase.split(' ');
      const caps = words.map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1);
      });
      return caps.join(' ');
    },

    capsInstallCity() {
      return this.capitalise(this.formData.installation_city);
    },

    capsDeliveryCity() {
      return this.capitalise(this.formData.delivery_city);
    },

    installCityValid() {
      this.installCityError = false;
      this.formData.installation_city = this.capsInstallCity();
      this.view += 1;
    },

    deliveryCityValid() {
      this.deliveryCityError = false;
      this.formData.delivery_city = this.capsDeliveryCity();
      this.view += 1;
    },

    installCityNotValid() {
      this.installCityError = true;
      this.invalidInstallCity = this.capsInstallCity();
      this.formData.installation_city = undefined;
    },

    deliveryCityNotValid() {
      this.deliveryCityError = true;
      this.invalidDeliveryCity = this.capsDeliveryCity();
      this.formData.delivery_city = undefined;
    },

    isCityValid() {
      const isInstallCityValid = this.citiesList.includes(
        this.capsInstallCity()
      );

      if (isInstallCityValid && this.deliveryAddressSame) {
        this.installCityValid();
      }
      if (!isInstallCityValid) {
        this.installCityNotValid();
      }

      if (isInstallCityValid && !this.deliveryAddressSame) {
        const isDeliveryCityValid = this.citiesList.includes(
          this.capsDeliveryCity()
        );
        this.installCityError = false;
        this.formData.installation_city = this.capsInstallCity();

        if (!isDeliveryCityValid) {
          this.deliveryCityNotValid();
        }

        if (isDeliveryCityValid) {
          this.deliveryCityValid();
        }
      }
    },

    formSubmit() {
      if (this.view < 3) {
        this.view += 1;
        return;
      }

      // honeypot
      if (this.formData.other !== null) {
        return;
      }

      if (this.deliveryAddressSame) {
        this.formData.delivery_address_1 = this.formData.installation_address_1;
        this.formData.delivery_address_2 = this.formData.installation_address_2;
        this.formData.delivery_address_3 = this.formData.installation_address_3;
        this.formData.delivery_city = this.formData.installation_city;
        this.formData.delivery_postcode = this.formData.installation_postcode;
        this.formData.delivery_country = this.formData.installation_country;
        this.formData.delivery_phone = this.formData.installation_phone;
      }

      this.formData.installation_phone = this.formData.mobile;
      this.formData.delivery_phone = this.formData.mobile;

      if (this.formData.ispId === -1) {
        this.formData.service_provider = "I don't know";
      } else {
        const isp = this.ispsForCountry.find(
          ({ id }) => id === this.formData.ispId
        );

        this.formData.service_provider = isp
          ? isp.name
          : this.formData.ispOther;
      }

      if (this.formData.productId === -1) {
        this.formData.package = "I don't know";
      } else {
        const userProduct = this.productsForIsp.find(
          ({ id }) => id === this.formData.productId
        );

        this.formData.package = userProduct
          ? userProduct.name
          : this.formData.productOther;
      }

      this.loading = true;
      this.formFeedback = [];
      this.errorCode = '';

      signupsService.submit(this.formData).then(({ code, message, errors }) => {
        if (code === 'OK') {
          this.loading = false;
          this.success = true;
          this.view += 1;
        } else {
          this.loading = false;

          this.formFeedback = errors;
          //use code for translations
          this.errorCode = message;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../scss/base/colors';
@import '../scss/helpers/mixins';

.split--thanks {
  margin-top: 20px;
}

img {
  max-width: 100%;
  margin-bottom: 2em;
}

.marked:first-child {
  margin-top: 0;
}

.left .text {
  padding: 0 20px;
}

.right {
  margin-top: 20px;
  padding: 0 20px;
}

.project-requirements {
  padding-left: 0;
  list-style-type: none;

  label {
    font-weight: normal;
  }
}

.buttons {
  display: flex;
  :first-child {
    margin-right: 20px;
    [dir='rtl'] & {
      margin-right: 0;
      margin-left: 20px;
    }
  }
}

.actions {
  display: flex;
  justify-content: center;
  > a {
    flex: 1;
    max-width: 135px;
    margin: 0 10px;
  }
  .web-test {
    font-size: 1em;
    height: 35px;
  }
}

.error {
  p {
    color: $error;
  }

  input {
    border: 1px solid $error;
  }
}

// honeypot
.other {
  display: none;
}

@include breakpoint(M) {
  .split {
    max-width: 1000px;
    margin: 0 auto;
    padding: 150px 20px;
    display: flex;
  }

  .left {
    flex: 1;
    padding-right: 40px;

    .text {
      padding: 0;
    }
  }
  .right {
    flex: 1;
    padding-left: 40px;
    margin-top: 0;
  }

  [dir='rtl'] {
    .left {
      padding-right: 0;
      padding-left: 40px;
    }

    .right {
      padding-left: 0;
      padding-right: 40px;
    }
  }
}
</style>
